import styled from 'styled-components';
import { COLORS } from 'assets/styled/colors';
import { marginSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${marginSm};
`;

export const Title = styled.div`
  font-size: 24rem;
  font-weight: 300;
  line-height: 36rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${COLORS.BLACK};
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20rem;
  gap: 20rem;

  ${respondTo.bigPhone`
    flex-direction: column;
    gap: 10rem;
  `}
`;

export const TopContainer = styled.div`
  margin-top: 20rem;
  padding: 15rem;
`;

export const Description = styled.div`
  font-size: 16rem;
  font-weight: 300;
  line-height: 21rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${COLORS.BLACK};
  white-space: pre-line;
`;
